export default __webpack_public_path__ + "static/media/struktur organisasi.ceefe803.png";